var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "member-detail",
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("基本信息")]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.goBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
          _c(
            "el-descriptions",
            { attrs: { column: 3, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "会员ID" } }, [
                _vm._v(_vm._s(_vm.memberDetail.memberId)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "用户名" } }, [
                _vm._v(_vm._s(_vm.memberDetail.username)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "账户状态" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getStatusTagType(_vm.memberDetail.status),
                        effect: "dark",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.memberDetail.statusText) + " ")]
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                _vm._v(_vm._s(_vm.memberDetail.mobile)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "邮箱" } }, [
                _vm._v(_vm._s(_vm.memberDetail.email)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "注册时间" } }, [
                _vm._v(_vm._s(_vm.memberDetail.registerTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "最后登录" } }, [
                _vm._v(_vm._s(_vm.memberDetail.lastLoginTime || "未登录")),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "20px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("账户信息")]),
          ]),
          _c(
            "el-descriptions",
            { attrs: { column: 3, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "账户余额" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      color: "#f56c6c",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(" $" + _vm._s(_vm.memberDetail.accountBalance) + " ")]
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "支付密码状态" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.memberDetail.paymentPasswordSet
                          ? "success"
                          : "warning",
                        effect: "dark",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.memberDetail.paymentPasswordSet
                              ? "已设置"
                              : "未设置"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "20px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("订单统计")]),
          ]),
          _c(
            "el-descriptions",
            { attrs: { column: 4, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "总订单数" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      color: "#409EFF",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.memberDetail.orderStatistics &&
                            _vm.memberDetail.orderStatistics.totalOrderCount) ||
                            0
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { "margin-left": "5px", color: "#909399" } },
                  [_vm._v("笔")]
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "成功订单数" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      color: "#67C23A",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.memberDetail.orderStatistics &&
                            _vm.memberDetail.orderStatistics
                              .successOrderCount) ||
                            0
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { "margin-left": "5px", color: "#909399" } },
                  [_vm._v("笔")]
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "退票订单数" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      color: "#E6A23C",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.memberDetail.orderStatistics &&
                            _vm.memberDetail.orderStatistics
                              .refundOrderCount) ||
                            0
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { "margin-left": "5px", color: "#909399" } },
                  [_vm._v("笔")]
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "改签订单数" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      color: "#909399",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.memberDetail.orderStatistics &&
                            _vm.memberDetail.orderStatistics
                              .changeOrderCount) ||
                            0
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { "margin-left": "5px", color: "#909399" } },
                  [_vm._v("笔")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("操作日志")]),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.memberDetail.operationLogs, border: "" } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60px" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作类型",
                  prop: "operationType",
                  width: "150px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作时间",
                  prop: "operationTime",
                  width: "160px",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作人", prop: "operator", width: "120px" },
              }),
              _c("el-table-column", {
                attrs: { label: "备注", prop: "remark" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }